/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import { useEffect, useRef, useState } from 'react';

import axios from 'axios';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import moment from 'moment';
import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import qs from 'qs';
import { Link as Slink } from 'react-scroll';
import Slider from 'react-slick';
import { Container } from 'reactstrap';
import { useSetRecoilState } from 'recoil';

import { retainerFormSubmit } from '../../apis/retainers';
import Collapse from '../../components/includes/collapse';
import ToastItem from '../../components/includes/toast-item';
import { pageviewEvent, retainerIdentify, getButtonDetails, remainingFill } from '../../helpers/retainer-segment';
import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap, countryDialCodeData } from '../../language.config';
import { socialLinks } from '../../links.config';
import { toast } from '../../recoil/selectors/notifications';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';
import { validateEmail, isValidName } from '../../utils/utils';
import '../../styles/globals/globals.scss';
import '../../styles/retainers.scss';

// CLEAN CODE move to config file
const recommendSlider = {
  dots: true,
  arrows: false,
  accessibility: true,
  infinite: false,
  speed: 700,
  slidesToShow: 3,
  centerPadding: 20,
  slidesToScroll: 1,
  swipe: true,
  touchThreshold: 30,
  beforeChange: (current, next) => {
    const activeNumber = Math.ceil(next) + 1;
    const slideLength = document.querySelectorAll('.slick-slider .slick-dots li').length;
    if (activeNumber === slideLength) {
      document.querySelector('.slick-slider .slick-dots li:last-of-type').classList.add('slick-active');
    } else {
      document.querySelector('.slick-slider .slick-dots li:last-of-type').classList.remove('slick-active');
    }
  },
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2.2
      }
    },
    {
      breakpoint: 768,
      settings: {
        swipe: true,
        arrows: false,
        slidesToShow: 1.2
      }
    },
    {
      breakpoint: 576,
      settings: {
        swipe: true,
        arrows: false,
        slidesToShow: 1.1
      }
    }
  ]
};

const Retainer = () => {
  const i18n = useI18n();
  const retainerLandingPage = i18n.t('retainer');
  const orientationMsg = i18n.t('orientation');
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const lang = codes[1] || 'en';
  const socialMedia = socialLinks[country] || socialLinks.sg;

  const phoneDropdown = useRef();
  const setToast = useSetRecoilState(toast);
  const router = useRouter();
  const query = router && router.query;
  const [isPhoneCodesOpen, setIsPhoneCodesOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const today = moment().format('YYYY/MM/DD HH:mm:ss');
  // const [firstClick, setFirstClick] = useState(false);
  const [isDataNotSub, setIsDataNotSub] = useState(true);
  const [productId, setProductId] = useState({
    productId1: '',
    productId2: ''
  });

  const [personDetails, setPersonDetails] = useState({
    name: '',
    email: query.myemail ? query.myemail : '',
    phone: '',
    straighter: 3,
    phoneIsdCode: countryDialCodeData[country].dialCode,
    phoneCountryCode: country,
    agreeToContinue: true,
    productId: productId.productId2
  });
  useEffect(() => {
    if (query.myemail) {
      setPersonDetails((data) => ({ ...data, email: query.myemail }));
    }
  }, [query.myemail]);
  const [defaultReqData, setDefaultReqData] = useState({
    name: '',
    email: '',
    phone: '',
    straighter: '',
    productId: '',
    phoneIsdCode: countryDialCodeData[country].dialCode,
    phoneCountryCode: country,
    utm_source: query.utm_source,
    utm_medium: query.utm_medium,
    utm_campaign: query.utm_campaign,
    utm_content: query.utm_content,
    country_code: country,
    submetted_date: today
  });
  const personalDetailsKeys = ['name', 'email', 'phone', 'straighter'];

  const [isActive, setActive] = useState(false);
  const ToggleClass = () => {
    setActive(!isActive);
  };
  const perfectSmileSelect = (index) => {
    ToggleClass();
    if (index === 0) {
      updateForm({ straighter: 1, productId: productId.productId1 });
    } else if (index === 1) {
      updateForm({ straighter: 3, productId: productId.productId2 });
    }
  };
  const [isActivePage, setActivePage] = useState(false);
  // const ToggleClassPage = () => {
  //   setActivePage(!isActivePage);
  // };
  const dropdown = useRef();
  const valueRef = useRef();

  useEffect(() => {
    valueRef.current = personDetails;
  }, [personDetails]);

  useEffect(() => {
    pageviewEvent('Retainer');
    document.addEventListener('mousedown', handleClick);
    loadProductDetails();
    return () => {
      const unfill = getUnfilledFields(valueRef.current);
      if (isDataNotSub && unfill.length < 4) {
        remainingFill(unfill);
      }
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const getUnfilledFields = (personDetailsTemp) => {
    const unfilledFields = personalDetailsKeys.filter((key) => !personDetailsTemp[key]);
    return unfilledFields;
  };

  const handleClick = (e) => {
    if ((dropdown.current && dropdown.current.contains(e.target)) || (phoneDropdown.current && phoneDropdown.current.contains(e.target))) {
      return;
    }
    setActive(false);
    setIsPhoneCodesOpen(false);
  };

  // CLEAN CODE move logic to seperate function
  useEffect(() => {
    if (query && (query.utm_source || query.utm_medium || query.referral_id || query.eid)) {
      setDefaultReqData({ ...defaultReqData, utm_source: query.utm_source || '', utm_medium: query.utm_medium || '', utm_content: query.utm_content || '', utm_campaign: query.utm_campaign || '', eid: query.eid || '', source_url: window.location.href });
    }
  }, [query]);

  // useEffect(() => {
  //   if (firstClick) {
  //     validateStraighter();
  //   }
  // }, [personDetails.straighter]);

  const updateForm = (data) => {
    let updatedDetails = { ...personDetails };
    Object.keys(data).forEach((key) => {
      updatedDetails = { ...updatedDetails, [key]: data[key] };
    });
    setPersonDetails(updatedDetails);
  };

  const setErrorField = (field, isValid) => {
    if (!isValid && !errors.includes(field)) {
      setErrors([...errors, field]);
    } else if (isValid && errors.includes(field)) {
      setErrors(errors.filter((errorField) => field !== errorField));
    }
  };

  const buttoncheck = () => {
    if (!personDetails.name || !personDetails.email || !personDetails.phone || !personDetails.straighter) {
      return false;
    }
    return true;
  };
  // CLEAN CODE can be written more efficiently
  const validateField = (event, field) => {
    if (event.keyCode === 13) {
      switch (field) {
        case 'name':
          validateName();
          break;

        case 'email':
          validateEmailId();
          break;

        case 'phone':
          validatePhoneNumber('phone', personDetails.phone, personDetails.phoneCountryCode);
          break;

        case 'straighter':
          validateStraighter();
          break;

        default:
          break;
      }
    }
  };

  const validateName = () => setErrorField('name', isValidName(personDetails.name));

  const validateEmailId = () => setErrorField('email', validateEmail(personDetails.email));

  const validatePhoneNumber = (field, fieldValue, countryCode) => setErrorField(field, fieldValue && isValidPhoneNumber(fieldValue, countryCode.toUpperCase()));

  const validateStraighter = () => setErrorField('straighter', !!personDetails.straighter);

  const onChangeOfAgreeToContinue = () => {
    const currentErrors = [];
    if (!personDetails.name) {
      currentErrors.push('name');
    }
    if (!validateEmail(personDetails.email)) {
      currentErrors.push('email');
    }
    if (!(personDetails.phone && isValidPhoneNumber(personDetails.phone, personDetails.phoneCountryCode.toUpperCase()))) {
      currentErrors.push('phone');
    }
    if (!personDetails.straighter) {
      currentErrors.push('straighter');
    }
    setErrors(currentErrors);
    if (currentErrors.length > 0) {
      return false;
    }
    return true;
  };

  const loadProductDetails = async () => {
    // const response = await getProductId();
    // if (response?.data[0].id || response?.data[1].id) {
    //   setProductId({
    //     productId1: response.data[0].id || '',
    //     productId2: response.data[1].id || ''
    //   });
    // }
    const newProductId = {
      productId1: `${process.env.NEXT_PUBLIC_RETAINER_RETAINERS_1}`,
      productId2: `${process.env.NEXT_PUBLIC_RETAINER_RETAINERS_2}`
    };
    setProductId(
      newProductId
    );
    let updatedDetails = { ...personDetails };
    updatedDetails = { ...updatedDetails, productId: newProductId.productId2 };
    setPersonDetails(updatedDetails);
  };

  const onFormSubmit = async () => {
    // reqData is the requested data
    if (onChangeOfAgreeToContinue()) {
      setIsLoading(true);
      // CLEAN CODE remove unwanted code
      const phoneNumber = `${personDetails.phoneIsdCode}${personDetails.phone ? parsePhoneNumber(personDetails.phone, personDetails.phoneCountryCode.toUpperCase()).formatNational() : ''}`;
      // const reqData = {
      //   2: personDetails.name,
      //   4: phoneNumber,
      //   5: personDetails.email,
      //   24: personDetails.straighter,
      //   7: defaultReqData.country_code,
      //   date_submitted: defaultReqData.submetted_date,
      //   8: defaultReqData.utm_source,
      //   9: defaultReqData.utm_medium,
      //   10: defaultReqData.utm_campaign,
      //   12: defaultReqData.utm_content
      // };
      const checkSub = await DataSub();
      if (checkSub) {
        retainerIdentify(personDetails.name, personDetails.email, phoneNumber, personDetails.straighter);
        setIsLoading(false);
        setIsDataNotSub(false);
      } else {
        setIsLoading(false);
        setToast('Something went wrong. Please try again.');
      }
    }
  };

  const options = {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
  };

  const DataSub = async () => {
    const phoneNumber = `${personDetails.phoneIsdCode}${personDetails.phone ? personDetails.phone : ''}`;
    const reqData = {
      2: personDetails.name,
      4: phoneNumber,
      5: personDetails.email,
      24: personDetails.straighter,
      7: defaultReqData.country_code,
      date_created: defaultReqData.submetted_date,
      8: defaultReqData.utm_source,
      9: defaultReqData.utm_medium,
      10: defaultReqData.utm_campaign,
      12: defaultReqData.utm_content

    };
    if (query.a_id && errors.length === 0) {
      const formDataSubmit = { name: personDetails.name, accountId: query.a_id, email: personDetails.email, phone: phoneNumber, isdCode: personDetails.phoneIsdCode, phoneNumber: personDetails.phone, productInfo: { productId: personDetails.productId }, utm_source: query.utm_source, utm_medium: query.utm_medium, utm_campaign: query.utm_campaign, utm_content: query.utm_content };
      const response = await retainerFormSubmit(formDataSubmit);
      if (response?.stage === 'Invoice Created') {
        window.open(response.invoice.paymentMethod.paymentLink, '_self');
        return true;
      }
      setActivePage(true);
      axios.post(`${process.env.NEXT_PUBLIC_RETAINER_ZAPIER}`,
        qs.stringify(reqData), options);
      return true;
    } if (errors.length === 0) {
      axios.post(`${process.env.NEXT_PUBLIC_RETAINER_ZAPIER}`,
        qs.stringify(reqData), options);
      setActivePage(true);
      return true;
    }
    return false;
  };

  return (
    <div className="wrapper retainer-page">
      <Head>
        <title>{retainerLandingPage.page_title}</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta name="description" content={retainerLandingPage.page_description} />
        <meta name="keywords" content={retainerLandingPage.page_keywords} />
        <meta name="author" content="Zenyum" />
        <meta httpEquiv="content-language" content={lang} />
        <meta property="og:title" content={retainerLandingPage.page_title} />
        <meta property="og:description" content={retainerLandingPage.page_description} />
        <meta property="og:image" content={`${process.env.NEXT_PUBLIC_BASE_URL}img/FB_zenyum_02.jpg`} />
        <meta httpEquiv="content-language" content={contentLanguageMap[i18n.activeLocale]} />

        <link rel="alternate" hrefLang="en" href="https://www.zenyum.com/sg-en" />
        <link rel="alternate" hrefLang="en-SG" href="https://www.zenyum.com/sg-en" />
        <link rel="alternate" hrefLang="en-MY" href="https://www.zenyum.com/my-en" />
        <link rel="alternate" hrefLang="en-HK" href="https://www.zenyum.com/hk-en" />
        <link rel="alternate" hrefLang="zh-HK" href="https://www.zenyum.com/hk-zh" />
        <link rel="alternate" hrefLang="zh-TW" href="https://www.zenyum.com/tw-zh" />
        <link rel="alternate" hrefLang="en-MY" href="https://www.zenyum.com/my-en" />
        <link rel="alternate" hrefLang="th" href="https://www.zenyum.com/th-th" />
        <link rel="alternate" hrefLang="id" href="https://www.zenyum.com/id-id" />
        <link rel="alternate" hrefLang="vi" href="https://www.zenyum.com/vn-vi" />

        <link rel="icon" href="/img/favicon.png" sizes="32x32" />
        <link rel="icon" href="/img/favicon.png" sizes="192x192" />
        <link rel="apple-touch-icon" href="/img/favicon.png" />
        {lang !== 'vi' && lang !== 'th' && lang !== 'zh' && (
        <link rel="stylesheet" href="/fonts/fonts.css" />
        )}
        {lang === 'vi' && <link rel="stylesheet" href="/fonts/fonts-vi.css" />}
        {lang === 'th' && <link rel="stylesheet" href="/fonts/fonts-th.css" />}
        {lang === 'zh' && <link rel="stylesheet" href="/fonts/fonts-zh.css" />}
        <link rel="stylesheet" href="/vendor/slick/slick.min.css" />
        <link rel="stylesheet" href="/vendor/slick/slick-theme.min.css" />
        <link rel="stylesheet" href="/vendor/bootstrap/css/bootstrap.min.css" />
      </Head>
      <header className="retainer-header">
        <Container>
          <nav>
            <Link href="/[lng]/" as={`/${i18n.activeLocale}/`}>
              <a className="nav-logo">
                {' '}
                {country === 'tw' ? (
                  <img src="/img/logo-tw.png" alt="Zenyum Logo" />
                ) : (
                  <img src="/img/logo.svg" alt="Zenyum Logo" />
                )}
              </a>
            </Link>
          </nav>
        </Container>

        <div className="orientation-msg">
          <div>
            <h2>{orientationMsg.title}</h2>
            <p>{orientationMsg.description}</p>
          </div>
        </div>
        <div className="toast-msg">
          <ToastItem />
        </div>
      </header>
      {!isActivePage && (
      <main className="retainer-main">
        <div className="new-smile-wraper">
          <div className="new-smile">
            <Container>
              <div className="new-smile-content">
                <h1 className="new-smile-heading">
                  {retainerLandingPage.page_heading_part1}
                  <br />
                  <span className="liner-color-heading">{retainerLandingPage.page_heading_part2}</span>
                </h1>
                <p className="new-smile-dec">{retainerLandingPage.keep_teeth}</p>
                <Slink to="form-section-id" spy={true} smooth={true} duration={500} offset={-70}>
                  <a className="new-smile-button" href="#form-section-id" id="retainer_banner_1" onClick={() => getButtonDetails('retainer_banner_1')}>{retainerLandingPage.button}</a>
                </Slink>
              </div>
            </Container>
          </div>
        </div>
        <div className="container-wraper">
          <Container>
            <div className="wear">
              <div className="wear-top">
                <h2>{retainerLandingPage.wear_your_retainers}</h2>
                <p>{retainerLandingPage.waste_your}</p>
              </div>
              <div className="wear-cards-wrapper">
                <div className="wear-cards">
                  {retainerLandingPage.wear_cards.map((card) => (
                    <div className="wear-one-card-wrapper">
                      <div className="wear-one-card">
                        <h3>{card.card_heading}</h3>
                        <p>{card.card_des}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <Slink to="form-section-id" spy={true} smooth={true} duration={500} offset={-70}>
                <div className="buy-now">
                  <a className="new-smile-button" href="#form-section-id" id="retainer_banner_1">{retainerLandingPage.wear_button}</a>
                </div>
              </Slink>
            </div>
            <div className="why">
              <h2 className="why-heading">{retainerLandingPage.why}</h2>
              <div className="why-cards-whole-wraper">
                <Slider {...recommendSlider}>
                  {retainerLandingPage.why_cards.map((card) => (
                    <div className="slider-wraper">
                      <div className="slider-cad">
                        <div className="card-image">
                          <img src={card.image} alt={card.card_heading} />
                        </div>
                        <div className="card-content">
                          <h5>{card.card_heading}</h5>
                          <p>{card.card_des}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </Container>
        </div>
        <div className="perfect-smile">
          <Container>
            <div className="perfect-smile-wrapper">
              <div className="perfect-smile-top">
                <h2 className="perfect-heading">{retainerLandingPage.perfect_smile_heading}</h2>
                <p>{retainerLandingPage.perfect_smile_des}</p>
              </div>
              <div className="perfect-smile-cards">
                {retainerLandingPage.perfect_smile_cards.map((card, index) => (
                  <div className="perfect-smile-card-wrapper">
                    <Slink to="form-section-id" spy={true} smooth={true} duration={500} offset={-70}>
                      <div
                        role="presentation"
                        className="perfect-smile-one-card"
                        onClick={() => {
                          perfectSmileSelect(index);
                        }}
                      >
                        <div className="perfect-smile-image">
                          <img src={card.image} alt="card" />
                        </div>
                        <div className="perfect-smile-content">
                          <div className="set-price">
                            <div className="sets">
                              <h4>{card.no_set}</h4>
                            </div>
                            <div className="price_section">
                              {card.price !== 'null' && <p className="price-original">{card.price}</p>}
                              <p className="price-offer">{card.offer_price}</p>
                            </div>
                          </div>
                          <div className="perfect-smile-card-description">
                            <p>{card.content}</p>
                          </div>
                        </div>
                      </div>
                    </Slink>
                  </div>
                ))}
              </div>
            </div>
          </Container>
        </div>
        <div className="straighter-teath">
          <Container>
            <div id="form-section-id" className="form-section">
              <h2 className="title referral-title" id="referralTitle">{retainerLandingPage.form_title}</h2>

              <div className={`title f-sm mb-8 ${errors.includes('name') ? 'error-title' : ''}`}>
                {retainerLandingPage.name}
                <span className="star-importent">*</span>
              </div>
              <input
                type="text"
                name="name"
                className={errors.includes('name') ? 'error-box' : ''}
                placeholder={retainerLandingPage.name_placeholder}
                value={personDetails.name}
                onChange={(evt) => updateForm({ name: evt.target.value })}
                onKeyDown={(event) => validateField(event, 'name')}
                onBlur={validateName}
              />
              {errors.includes('name') && (
                <div className="d-flex mt-8">
                  <img src="/img/error.svg" alt="error icon" width={14} height={14} />
                  <span className="error-title f-xs ml-8">{retainerLandingPage.invalid_name}</span>
                </div>
              )}

              <div className={`title f-sm mb-8 mt-16 ${errors.includes('phone') ? 'error-title' : ''}`}>
                {retainerLandingPage.phone_number}
                <span className="star-importent">*</span>
              </div>
              <div className="d-flex phone-number-section">
                <div
                  className={`input-default btn text-left ${errors.includes('phone') ? 'error-box' : ''}`}
                  onClick={() => setIsPhoneCodesOpen(!isPhoneCodesOpen)}
                  role="presentation"
                  ref={phoneDropdown}
                >
                  <div className="flag-box"><div className={`iti-flag ${personDetails.phoneCountryCode}`} /></div>
                  <span className="f-sm">{personDetails.phoneIsdCode}</span>
                  <img className="droparrow" src="/img/clinic-selection/accordion-arrow.svg" data-gumlet="false" alt="accordion arrow" />
                  <ul className={`country-list ${isPhoneCodesOpen ? 'show' : 'hide'}`} id="country-listbox">
                    {countryDialCodeData && Object.keys(countryDialCodeData).map((key) => (
                      <li
                        className="country standard"
                        role="presentation"
                        onClick={() => { updateForm({ phoneIsdCode: countryDialCodeData[key].dialCode, phoneCountryCode: key }); validatePhoneNumber('phone', personDetails.phone, key); }}
                      >
                        <div className="flag-box"><div className={`iti-flag ${key}`} /></div>
                        <span className="country-name">{countryDialCodeData[key].name}</span>
                        <span className="dial-code">{countryDialCodeData[key].dialCode}</span>
                      </li>
                    ))}

                  </ul>
                </div>
                <input
                  type="text"
                  name="phone"
                  className={errors.includes('phone') ? 'error-box' : ''}
                  placeholder={retainerLandingPage.phone_number_placeholder}
                  value={personDetails.phone}
                  onChange={(evt) => updateForm({ phone: evt.target.value })}
                  onKeyDown={(event) => validateField(event, 'phone')}
                  onBlur={() => validatePhoneNumber('phone', personDetails.phone, personDetails.phoneCountryCode)}
                />
              </div>
              {errors.includes('phone') && (
                <div className="d-flex mt-8">
                  <img src="/img/error.svg" alt="error icon" width={14} height={14} />
                  <span className="error-title f-xs ml-8">{retainerLandingPage.invalid_phone}</span>
                </div>
              )}

              <div className={`title f-sm mb-8 mt-16 ${errors.includes('email') ? 'error-title' : ''}`}>
                {retainerLandingPage.email}
                <span className="star-importent">*</span>
              </div>
              <input
                type="text"
                name="email"
                className={errors.includes('email') ? 'error-box' : ''}
                placeholder={retainerLandingPage.email_placeholder}
                value={personDetails.email}
                onChange={(evt) => updateForm({ email: evt.target.value })}
                onKeyDown={(event) => validateField(event, 'email')}
                onBlur={validateEmailId}
              />
              {errors.includes('email') && (
                <div className="d-flex mt-8">
                  <img src="/img/error.svg" alt="error icon" width={14} height={14} />
                  <span className="error-title f-xs ml-8">{retainerLandingPage.invalid_email}</span>
                </div>
              )}
              <div className={`title f-sm mb-8 mt-16 ${errors.includes('straighter') ? 'error-title' : ''}`}>
                {retainerLandingPage.straighter}
                <span className="star-importent">*</span>
              </div>
              <div
                className="selector-wraper"
                ref={dropdown}
              >
                <div className="options">
                  <button
                    type="button"
                    className={personDetails.straighter === 1 ? 'button-active' : ''}
                    onClick={() => {
                      updateForm({ straighter: 1, productId: productId.productId1 });
                    }}
                  >
                    <div className="number-of-sets-button">
                      <div className="number-of-sets-button-top">
                        {retainerLandingPage.perfect_smile_cards[0].no_set}
                      </div>
                      <div className="number-of-sets-button-bottom">
                        <div className="number-of-sets-button-price">
                          {retainerLandingPage.price_set1}
                        </div>
                      </div>
                    </div>

                  </button>
                  <button
                    type="button"
                    className={personDetails.straighter === 3 ? 'button-active' : ''}
                    onClick={() => {
                      updateForm({ straighter: 3, productId: productId.productId2 });
                    }}
                  >
                    <div className="number-of-sets-button">
                      <div className="number-of-sets-button-top">
                        {retainerLandingPage.perfect_smile_cards[1].no_set}
                      </div>
                      <div className="number-of-sets-button-bottom">
                        <div className="number-of-sets-button-price">
                          {retainerLandingPage.price_set3}
                        </div>
                        <div className="number-of-sets-button-old-price">
                          {retainerLandingPage.price_set3_original !== 'null' && retainerLandingPage.price_set3_original}
                        </div>
                      </div>
                    </div>

                  </button>
                </div>
              </div>
              {errors.includes('straighter') && (
                <div className="d-flex mt-8">
                  <img src="/img/error.svg" alt="error icon" width={14} height={14} />
                  <span className="error-title f-xs ml-8">{retainerLandingPage.straighter_invalid}</span>
                </div>
              )}
              <button type="button" className={`web-btn ${errors.length ? 'disabled' : ''} ${!buttoncheck() ? 'disabled' : ''}`} onClick={onFormSubmit}>
                {isLoading ? (<div className="loader position-absolute" />) : retainerLandingPage.submit_now}
              </button>
              <div className="from-button-bellow-text">
                <p>{retainerLandingPage.for_current}</p>
              </div>

            </div>
          </Container>
        </div>
        <div className="faq">
          <Container>
            <h4>{retainerLandingPage.retainer_faq_heading}</h4>
            <div className="faq-section-wrapper">
              <div className="faq-section">
                {retainerLandingPage.retainer_faq.map((RetainerFaq, index) => (
                  <div className="faq-collapse-wrapper">
                    <Collapse
                      title={RetainerFaq.question}
                      content={RetainerFaq.answer}
                      type="Retainers"
                      itemNumber={index + 1}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Container>
        </div>
        <footer className="retainer-footer">
          <div className="d-flex justify-content-center mb-24">
            <a href={socialMedia.facebook} target="_blank" rel="noreferrer" className="social-media">
              <img src="/img/fb_black_bg_white.svg" className="social-media-icon" alt="facebook" />
            </a>
            <a href={socialMedia.instagram} target="_blank" rel="noreferrer" className="social-media ml-16">
              <img src="/img/ig_black.svg" className="social-media-icon" alt="instagram" />
            </a>
            <a href={socialMedia.youtube} target="_blank" rel="noreferrer" className={`social-media ml-16 ${country === 'jp' ? 'd-none' : ''}`}>
              <img src="/img/icon_youtube_black.svg" className="social-media-icon" alt="youtube" />
            </a>
          </div>
          <div className="content f-md">{retainerLandingPage.zenyum_pte_ltd}</div>
          <div className="content f-md mb-16">{retainerLandingPage.zenyum_address}</div>
          <div className="content f-xs mb-8">{retainerLandingPage.partner_clinics_islandwide}</div>
          <div className="content f-xs mb-8">{retainerLandingPage.footer_text}</div>
          <div className="content f-xs">{retainerLandingPage.copy_right}</div>
        </footer>
      </main>
      ) }
      {isActivePage && (
      <div className="white-screen">
        <div className="sucess-img">
          <img src="/img/retainers/Sucess.png" alt="success icon" />
        </div>
        <div className="sucess-content">
          <h2>{retainerLandingPage.thanks_for}</h2>
          <p>{retainerLandingPage.we_have}</p>
        </div>
      </div>) }
    </div>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.RETAINERS;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default Retainer;
